export enum Capability {
	ArrayAt
}

export interface Polyfill {
	is_missing: () => boolean,
	init: () => void
}

export const default_polyfills: Record<Capability, Polyfill> = {
	[Capability.ArrayAt]: {
		is_missing: () => typeof Array.prototype.at !== "function",
		init: polyfill_array_at
	}
};

export function polyfill_array_at(): void {
	function at(n) {
		n = Math.trunc(n) || 0;
		if (n < 0) n += this.length;
		if (n < 0 || n >= this.length) return undefined;
		return this[n];
	}

	Object.defineProperty(Array.prototype, "at", {
		value: at, writable: true, enumerable: false, configurable: true
	});
}

export function init(polyfills: Polyfill[]): void {
	for (const polyfill of polyfills) {
		if (polyfill.is_missing()) {
			polyfill.init();
		}
	}
}
